// extracted by mini-css-extract-plugin
export default {"container":"About_container__w3NkW","link":"About_link__dEBnn"};